import { AppContext } from 'constants/contexts';
import useConfig from 'hooks/useConfig';
import {
  useContext,
  useRef,
  useState,
} from 'react';
import useDebouncedEffect from 'use-debounced-effect';

export default function useAutoComplete(query) {
  const [results, setResults] = useState([]);
  const mapRestriction = useConfig('general.mapRestriction');
  const [loading, setLoading] = useState(false);

  const { isGoogleMapsLoaded } = useContext(AppContext);

  const serviceRef = useRef();
  if (!serviceRef.current && window.google?.maps) {
    window.google.maps.importLibrary('places').then((places) => {
      serviceRef.current = new places.AutocompleteService();
    });
  }
  useDebouncedEffect(() => {
    if (!serviceRef.current || !query || query.length < 3) {
      return;
    }
    const request = { input: query };
    if (mapRestriction?.boundary) {
      request.locationRestriction = mapRestriction.boundary;
    } else if (mapRestriction?.countries) {
      request.componentRestrictions = mapRestriction.countries;
    }
    setLoading(true);
    serviceRef.current.getPlacePredictions(request, (predictions, status) => {
      setLoading(false);
      if (status !== 'OK' || !predictions) {
        return;
      }
      // we can also allow results with 'premise' type which is not accurate as "street_address"
      setResults(predictions.map((p) => ({
        placeId: p.place_id,
        label: p.structured_formatting?.main_text,
        text: p.description,
        subtitle: p.structured_formatting?.secondary_text,
        inaccurate: !p.types.includes('street_address'),
      })));
    });
  }, 500, [query]);

  return { options: results, loading: loading || !isGoogleMapsLoaded };
}
